export default {"src":"/_next/static/media/circles_24.70f7828a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};